class DtcReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.wrap = this.querySelector('.social-proof__track-wrap');
    this.track = this.querySelector('.social-proof__track');
    this.prevBtn = this.querySelector('[name="previous"]');
    this.nextBtn = this.querySelector('[name="next"]');
    if (!this.wrap || !this.track) return;

    this.onPrev = () => this.scrollByPage(-1);
    this.onNext = () => this.scrollByPage(1);
    this.onScroll = () => this.updateNav();
    this.onResize = () => this.updateNav();

    this.prevBtn?.addEventListener('click', this.onPrev);
    this.nextBtn?.addEventListener('click', this.onNext);
    this.wrap.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.updateNav();
    requestAnimationFrame(() => this.updateNav());
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.onPrev);
    this.nextBtn?.removeEventListener('click', this.onNext);
    this.wrap?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  getStep() {
    const slide = this.track.querySelector('.social-proof__slide');
    if (!slide) return this.wrap.clientWidth;
    const width = slide.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
    const visible = Math.max(1, Math.floor((this.wrap.clientWidth + gap) / (width + gap)));
    return (width + gap) * visible;
  }

  scrollByPage(direction) {
    this.wrap.scrollBy({ left: direction * this.getStep(), behavior: 'smooth' });
  }

  updateNav() {
    const max = this.wrap.scrollWidth - this.wrap.clientWidth - 2;
    const atStart = this.wrap.scrollLeft <= 2;
    const atEnd = this.wrap.scrollLeft >= max;
    const needsNav = this.wrap.scrollWidth > this.wrap.clientWidth + 4;

    this.prevBtn && ((this.prevBtn.disabled = atStart), this.prevBtn.classList.toggle('is-disabled', atStart));
    this.nextBtn && ((this.nextBtn.disabled = atEnd), this.nextBtn.classList.toggle('is-disabled', atEnd));
    this.classList.toggle('social-proof__slider--has-nav', needsNav);
  }
}

if (!customElements.get('dtc-reviews-carousel')) {
  customElements.define('dtc-reviews-carousel', DtcReviewsCarousel);
}
